const _excluded = ["children", "rtl", "className", "anchorUrlParameter"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
import './TestimonialCarousel.css';
import React, { useRef } from 'react';
import ComponentsWrapper from "../atoms/ComponentsWrapper";
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import CarouselProvider from '../atoms/CarouselProvider/CarouselProvider';
import { get, getGlobalDictionaryTerm } from '../../utils';
import { TestimonialCarouselCard } from '../51_TestimonialCarouselCard/TestimonialCarouselCard';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import { convertToAnalyticObject } from '../../utils/analytics';
const TestimonialCarousel = _ref2 => {
  let {
    fields,
    params
  } = _ref2;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  const newWindowLabel = getGlobalDictionaryTerm(sitecoreContext, 'newWindowLabel') || "Opens in a new window";
  const ctaLink = get(fields, "data.item.ctaLink.jss.value.href", "");
  const ctaLabel = get(fields, "data.item.ctaLabel.jss.value", "");
  const currentIndex = useRef(0);
  const items = get(fields, 'data.item.children', []);
  let eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  const renderItems = () => {
    return items.map(item => /*#__PURE__*/React.createElement("div", {
      key: item.name,
      className: "testimonial__list"
    }, /*#__PURE__*/React.createElement(TestimonialCarouselCard, {
      inCarousel: items.length > 1,
      params: params,
      image: item.authorPicture,
      authorName: item.authorName,
      authorDescription: item.authorDescription,
      quoteText: item.quoteText,
      title: item.title,
      hasQuoteMark: item.hasQuoteMark,
      video: item.video,
      onVideoBtnClick: val => tealiumClickFunc(tealiumMergeClickData(eventsAnalytics["playPausedVideo"], params), [val, item.title.jss.value])
    })));
  };
  const seeMoreTracking = ctaLabel => {
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics["seeMore"], params), ctaLabel);
  };
  if (!fields) {
    console.info('TestimonialMultipleMedia component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [TestimonialMultipleMedia component is empty: please provide data source]");
    }
    return null;
  }
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    className: "testimonial"
  }, items.length > 1 ? /*#__PURE__*/React.createElement(CarouselProvider, {
    getCurrentActiveItem: nextSlide => currentIndex.current = nextSlide
  }, _ref3 => {
    let {
      renderCarousel,
      renderPreviousButton,
      renderNextButton,
      renderDots
    } = _ref3;
    return /*#__PURE__*/React.createElement("div", {
      className: "row testimonial-multiple"
    }, renderCarousel(renderItems(), {
      responsive: {
        desktop: {
          breakpoint: {
            max: 10000,
            min: 0
          },
          items: 1
        },
        mobile: {
          breakpoint: {
            max: 479,
            min: 0
          },
          items: 1
        }
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: `btn-group--right btn-group-arrows ${rtl ? 'btn-group-rtl' : ''}`
    }, renderPreviousButton(() => tealiumClickFunc(tealiumMergeClickData(eventsAnalytics["operatingOptionsNextPrevious"], params), "previous")), renderNextButton(() => tealiumClickFunc(tealiumMergeClickData(eventsAnalytics["operatingOptionsNextPrevious"], params), "next"))), /*#__PURE__*/React.createElement("div", {
      className: "testimonial__bottom-wrapper"
    }, ctaLabel && /*#__PURE__*/React.createElement("a", {
      href: ctaLink,
      target: "_blank",
      "aria-label": `${ctaLabel} | ${newWindowLabel}`,
      rel: "noopener noreferrer",
      className: "btn btn-secondary",
      onClick: () => seeMoreTracking(ctaLabel)
    }, ctaLabel), renderDots(() => tealiumClickFunc(tealiumMergeClickData(eventsAnalytics["operatingOptionsNavigatorBubbles"], params)))));
  }) : renderItems()));
};
const StyledWrapper = _ref => {
  let {
      children,
      rtl,
      className,
      anchorUrlParameter
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(ComponentsWrapper, _extends({
    anchorUrlParameter: anchorUrlParameter,
    minHeight: true,
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles} ${className}`
  }, otherProps), children);
};
export const commonStyles = "co3z9lh";
export default TestimonialCarousel;
export const ltrStyles = "l1rk2vwk";
export const rtlStyles = "r570127";